import React from 'react';

export default class TestJsBridge extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toastMessage: '',
      showToast: false
    };
  }

  showToast = (message) => {
    this.setState({ toastMessage: message, showToast: true });
    setTimeout(() => {
      this.setState({ showToast: false });
    }, 2000);
  }

  handleDownload = async () => {
    if (window.zkzm) {
      try {
        this.showToast('尝试文件下载..');
        const item = {
          url: 'http://mirror.aarnet.edu.au/pub/TED-talks/911Mothers_2010W-480p.mp4',
          fileName: '123'
        };
        this.showToast(`fileURL: ${item.url}, fileName: ${item.fileName}`);
        await window.zkzm.callHandler('downloadFile', {
          fileURL: item.url,
          fileName: item.fileName
        })
      } catch (err) {
        this.showToast(`错误: ${err}`);
      }
    } else {
      this.showToast('window.zkzm 不存在');
    }
  }

  render() {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        <button 
          onClick={this.handleDownload}
          style={{
            marginTop: '20px',
            padding: '10px 20px',
            fontSize: '16px',
            backgroundColor: '#007AFF',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer'
          }}
        >
          测试下载文件
        </button>
        
        {this.state.showToast && (
          <div style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '8px',
            fontSize: '14px',
            maxWidth: '80%',
            wordBreak: 'break-word',
            zIndex: 9999,
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
          }}>
            {this.state.toastMessage}
          </div>
        )}
      </div>
    );
  }
}
